import React from "react";
import { Button, Grid, Modal } from "@material-ui/core";
import Heading from "../Heading/Heading";
import { UserDashboardContext } from "../../pages/UserDashboard/UserDashboard";
import OrderStatus from "../OrderStatus/OrderStatus";
import OrderTracker from "../OrderTracker/OrderTracker";
import axios from "../../utils/Axios/axiosProxy";
import { withTranslation } from "react-i18next";
import i18n from "../../utils/LanguageSelector/i18n";
import "./LastOrderPreview.scss";

function LastOrderPreview({ lastOrder }) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const dashboardContext = React.useContext(UserDashboardContext);
  const documentLabels = {
    freightbill: i18n.t("general.freightbill"),
    invoice: i18n.t("general.invoice"),
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const getPDF = (filename) => {
    axios
      .get(`/pdf/${filename}.pdf`, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        window.open(response.data.url, "_blank");
        console.log("GET PDF RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("GET PDF ERROR: ", error);
      })
      .catch((error) => console.log("GET PDF CLIENT ERROR", error));
  };

  const displayDocuments = (orderDocuments) => {
    let documents = [];
    for (let i in orderDocuments) {
      documents.push(
        <div className="NChild Padding8" key={i}>
          <p
            style={{ alignItems: "center" }}
            className="Italic NoMargin SpaceBetween"
          >
            {`${documentLabels[i] ? documentLabels[i] : i}`}
            <span className="FloatRight">
              <Button
                className="TransparentBlue Small"
                onClick={() => {
                  getPDF(orderDocuments[i]);
                }}
              >
                {i18n.t("general.download")}
              </Button>
            </span>
          </p>
        </div>
      );
    }
    return documents;
  };

  return (
    <Grid item md={7} xs={11}>
      <Heading
        title={i18n.t("dashboard.lastorder")}
        className="ToreaBay Medium"
        button
        buttonNr2
        titleB2={i18n.t("dashboard.seeall")}
        titleB={i18n.t("dashboard.showdetails")}
        onClick={() => setModalOpen(true)}
        onClick2={() => dashboardContext.handleNavigation("Shipments")}
      />
      <OrderTracker order={lastOrder} />
      <Grid container>
        <Grid item sm={6} xs={12}>
          <p className="OrangeFont Bold Padding8 NoMargin">
            {i18n.t("general.documents")}
            {/*   <span className="FloatRight">
              <Button className="ToreaBay Small">See all</Button>
            </span>  */}
          </p>
          {lastOrder.documents ? (
            displayDocuments(lastOrder.documents)
          ) : (
            <div className="FlexCenter" style={{ minHeight: "150px" }}>
              <p className="Bold Padding8"> {i18n.t("general.nodocuments")}</p>
            </div>
          )}
        </Grid>
        <Grid item sm={6} xs={12}>
          <p className="OrangeFont Bold Padding8 NoMargin">
            {" "}
            {i18n.t("matable.payment")}
          </p>
          <div className="FlexCenter PaymentContainer Column">
            {lastOrder !== undefined ? (
              <>
                <p className="Bold NoMargin">{lastOrder.paymentdue}</p>
                <p className="Bold NoMargin">{lastOrder.paymentlabel}</p>
              </>
            ) : null}
          </div>
        </Grid>
      </Grid>
      <Modal
        className="FlexCenter"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpen}
        onClose={() => handleClose()}
      >
        <OrderStatus content={lastOrder} />
      </Modal>
    </Grid>
  );
}

export default withTranslation()(LastOrderPreview);
